import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminProductTable from './AdminProductTable';
import AdminProductDetailsView from './AdminProductDetailsView';
import AdminBulkEditProductsView from './AdminBulkEditProductsView';

const AdminProductsViews = () => (
  <Routes>
    <Route element={<AdminBulkEditProductsView />} path="/bulk-edit" />
    <Route element={<AdminProductDetailsView newProduct />} path="/new" />
    <Route
      element={<AdminProductDetailsView />}
      path="/:pkEcomExternalProduct/*"
    />
    <Route element={<AdminProductTable />} path="/" />
    <Route element={<Navigate replace to="/admin/products" />} path="*" />
  </Routes>
);

AdminProductsViews.propTypes = {};

export default AdminProductsViews;
